import { useStorage } from '@vueuse/core';

export const useHiddenInputs = () => {
  const isHiddenInputs = useStorage('isHiddenInputs', true);

  function toggleHiddenInputs() {
    isHiddenInputs.value = !isHiddenInputs.value;
  }

  return {
    isHiddenInputs,
    toggleHiddenInputs,
  };
};
